import { isDefined } from '@zorro/clients';
import { Group, Stack, Text } from '@zorro/web/design-system';
import { ReactNode } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { PaymentStatusFormFields } from '../Payments/PaymentStatus/PaymentStatusFormFields';
import { PaymentStatusFormInput } from '../Payments/PaymentStatus/PaymentStatusUtils';

type Props = {
  sectionNumber?: number;
  paymentStatusForm: UseFormReturn<PaymentStatusFormInput>;
  onboardingPeriodId: string;
  title?: string;
  shouldShowCompleted?: boolean;
  isDisabled?: boolean;
  headerAction?: ReactNode;
};

export const PaymentStatusSection = ({
  sectionNumber,
  paymentStatusForm,
  onboardingPeriodId,
  title = 'Update payment status',
  shouldShowCompleted,
  isDisabled,
  headerAction,
}: Props) => {
  const isNumbered = isDefined(sectionNumber);

  return (
    <Stack my="xl" ml={isNumbered ? 'xs' : 0} gap="xxs">
      <Group justify="space-between" align="center" wrap="nowrap">
        <Text w="100%" size="md" fw={600}>
          {isNumbered ? `${sectionNumber}. ${title}` : title}
        </Text>
        {headerAction}
      </Group>
      <Stack ml={isNumbered ? 'md' : 0} gap={isNumbered ? 'lg' : '2rem'}>
        <Text size="sm" c="var(--color-text-default-secondary)">
          Confirm who is responsible for payment and the current payment status
        </Text>
        {/* Always on: these fields are required by paymentStatusSchema on
            Section surfaces, so the asterisks must always show. */}
        <PaymentStatusFormFields
          paymentStatusForm={paymentStatusForm}
          onboardingPeriodId={onboardingPeriodId}
          shouldShowCompleted={shouldShowCompleted}
          isDisabled={isDisabled}
          isFinalizationMode
        />
      </Stack>
    </Stack>
  );
};
